// @ts-strict-ignore
import React from 'react';
import { MultiSelectComponents } from '@usealloy/component-library';
import type { OptionProps } from '@usealloy/component-library';
import type { OutcomeOption } from './types';
import { StyledDropdownSingleValueText } from './styles';

interface EditOutcomeSingleValueProps extends OptionProps<OutcomeOption, false> { }
export default function EditOutcomeSingleValue(props: EditOutcomeSingleValueProps) {
  const {
    data: {
      label,
      meta: {
        color,
      } = {},
    },
  } = props;

  return (
    <MultiSelectComponents.SingleValue {...props}>
      <StyledDropdownSingleValueText color={color}>
        {label}
      </StyledDropdownSingleValueText>
    </MultiSelectComponents.SingleValue>
  );
}
